import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, gameCount }) => (
  <div className="card-flat p-5">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="no-scrollbar flex gap-2 overflow-x-auto pb-1">
        {categories?.map((c) => {
          const isActive = activeCategory === c?.id;
          return (
            <button
              key={c?.id}
              onClick={() => onCategoryChange(c?.id)}
              className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium transition-all duration-300 ease-royal ${
                isActive
                  ? 'bg-gradient-royal text-[#150F02] shadow-[0_1px_0_rgba(255,255,255,0.6)_inset,0_12px_24px_-14px_rgba(240,194,75,0.95)]'
                  : 'border border-white/10 bg-white/[0.05] text-white/65 hover:-translate-y-0.5 hover:border-royal-gold/40 hover:text-white'
              }`}
            >
              <Icon name={c?.icon || 'LayoutGrid'} size={15} />
              {c?.name}
              {typeof c?.count === 'number' && (
                <span
                  className={`rounded-full px-1.5 py-0.5 text-[0.62rem] ${
                    isActive ? 'bg-black/20 text-[#150F02]' : 'bg-white/10 text-white/50'
                  }`}
                >
                  {c?.count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      <span className="shrink-0 text-xs text-white/45">
        Showing <strong className="text-royal-gold">{gameCount}</strong> tables
      </span>
    </div>
  </div>
);

export default CategoryFilter;
